import { ConsumableQuantityEstimationThemeModeConfig } from './types';

const dark: ConsumableQuantityEstimationThemeModeConfig = {
  consumableQuantityEstimation: {},
};

export default dark;
